"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseTime = parseTime;
exports.formatTime = formatTime;
exports.getQueryObject = getQueryObject;
exports.getByteLen = getByteLen;
exports.cleanArray = cleanArray;
exports.param = param;
exports.param2Obj = param2Obj;
exports.html2Text = html2Text;
exports.objectMerge = objectMerge;
exports.toggleClass = toggleClass;
exports.debounce = debounce;
exports.camelcaseToHyphen = camelcaseToHyphen;
exports.hasPermission = hasPermission;
exports.isEmptyObj = isEmptyObj;
exports.segmentation = segmentation;
exports.backfill = backfill;
exports.setItemDisabled = setItemDisabled;
exports.getParent = getParent;
exports.getChild = getChild;
exports.bcryptEncryption = bcryptEncryption;
exports.percentage = percentage;
exports.normalSize = normalSize;
exports.normalTimes = normalTimes;
exports.getItemById = getItemById;
exports.getValueByKey = getValueByKey;
exports.setByPropPath = setByPropPath;
exports.contains = exports.off = exports.on = void 0;

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.date.now.js");

require("core-js/modules/es.array.last-index-of.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/web.timers.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.find.js");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _lodash = _interopRequireDefault(require("lodash"));

var _assignValue = _interopRequireDefault(require("lodash/_assignValue"));

var _castPath = _interopRequireDefault(require("lodash/_castPath"));

var _isIndex = _interopRequireDefault(require("lodash/_isIndex"));

var _toKey = _interopRequireDefault(require("lodash/_toKey"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _vue = _interopRequireDefault(require("vue"));

/**
 * Created by wqw on 16/11/18.
 */
var isServer = _vue["default"].prototype.$isServer;

function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;

  if ((0, _typeof2["default"])(time) === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }

  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];

    if (key === 'a') {
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    }

    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }

    return value || 0;
  });
  return timeStr;
}

function formatTime(time, option) {
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }

  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
} // 格式化时间


function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}
/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */


function getByteLen(val) {
  var len = 0;

  for (var i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1;
    } else {
      len += 0.5;
    }
  }

  return Math.floor(len);
}

function cleanArray(actual) {
  var newArray = [];

  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }

  return newArray;
}

function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}

function param2Obj(url) {
  var search = url.split('?')[1];

  if (!search) {
    return {};
  }

  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

function objectMerge(target, source) {
  /* Merges two  objects,
   giving the last one precedence */
  if ((0, _typeof2["default"])(target) !== 'object') {
    target = {};
  }

  if (Array.isArray(source)) {
    return source.slice();
  }

  for (var property in source) {
    if (Object.prototype.hasOwnProperty.call(source, property)) {
      var sourceProperty = source[property];

      if ((0, _typeof2["default"])(sourceProperty) === 'object') {
        target[property] = objectMerge(target[property], sourceProperty);
        continue;
      }

      target[property] = sourceProperty;
    }
  }

  return target;
} // export function scrollTo(element, to, duration) {
//   if (duration <= 0) return;
//   const difference = to - element.scrollTop;
//   const perTick = (difference / duration) * 10;
//   setTimeout(() => {
//     console.log(new Date());
//     element.scrollTop = element.scrollTop + perTick;
//     if (element.scrollTop === to) return;
//     scrollTo(element, to, duration - 10);
//   }, 10);
// }


function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }

  var classString = element.className;
  var nameIndex = classString.indexOf(className);

  if (nameIndex === -1) {
    classString += ' ' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }

  element.className = classString;
}

function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;

  var later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp; // 上次被包装函数被调用时间间隔last小于设定时间间隔wait

    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null; // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用

      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout; // 如果延时不存在，重新设定延时

    if (!timeout) timeout = setTimeout(later, wait);

    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
} // export function deepClone(source) {
//   if (!source && typeof source !== 'object') {
//     throw new Error('error arguments', 'shallowClone');
//   }
//   const targetObj = source.constructor === Array ? [] : {};
//   for (const keys in source) {
//     if (source.hasOwnProperty(keys)) {
//       if (source[keys] && typeof source[keys] === 'object') {
//         targetObj[keys] = source[keys].constructor === Array ? [] : {};
//         targetObj[keys] = deepClone(source[keys]);
//       } else {
//         targetObj[keys] = source[keys];
//       }
//     }
//   }
//   return targetObj;
// }


function camelcaseToHyphen(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

exports.on = on;

var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */


exports.off = off;

function hasPermission(menus, route) {
  if (route && route.name) {
    // return menus.some(role => route.meta.role.indexOf(role) >= 0)
    return route.noAuth || menus[route.name] || false;
  } else {
    return false;
  }
}
/**
 * 判断字符串是否为空或null undefine
 */


function isEmptyObj(str) {
  return str === null || str === undefined || str === '' || // str === 'null' ||
  // str === 'undefined' ||
  _lodash["default"].isArray(str) && !str.length;
}

var contains = document.documentElement.contains ? function (parent, node) {
  return parent !== node && parent.contains(node);
} : function (parent, node) {
  while (node && (node = node.parentNode)) {
    if (node === parent) {
      return true;
    }
  }

  return false;
};
exports.contains = contains;

function segmentation(str, symbol) {
  var index = str.indexOf(symbol);
  return [str.substr(0, index), str.substr(index + 1, str.length)];
}
/**
 * 模型数据回填值
 * @param {Object} metaData 数据模型
 * @param {Object} options 回填的数据值
 * @param {Object} formMetaData 数据模型中已经配置的默认数据，用于补充回填
 * @param {Array} filledProps 已经回填的数据项，用于标记操作以免重复回填
 */


function backfill(metaData, options, formMetaData) {
  var filledProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var flag = false;

  for (var name in options) {
    if (Object.prototype.hasOwnProperty.call(options, name)) {
      // 通过path
      if (name.indexOf('.') >= 0) {
        setByPropPath(metaData, name, options[name]);
        continue;
      }

      for (var pro in metaData) {
        if (Object.prototype.hasOwnProperty.call(metaData, pro) && _lodash["default"].indexOf(filledProps, pro) < 0) {
          if (metaData.$id === name) {
            metaData.$default = metaData.format ? metaData.format(metaData, options[name]) : options[name];
            flag = true;
            filledProps.push(name); // 标识已被赋值了

            break;
          } else if (!_lodash["default"].isFunction(metaData[pro]) && name === pro) {
            var formItemMetaData = formMetaData && getItemById(formMetaData, name);

            if (formItemMetaData && formItemMetaData.format) {
              metaData[pro] = formItemMetaData.format(formItemMetaData, options[name], metaData, options);
            } else {
              metaData[pro] = options[name];
            }

            filledProps.push(pro);
            break;
          } else if (_lodash["default"].isPlainObject(metaData[pro])) {
            backfill(metaData[pro], (0, _defineProperty2["default"])({}, name, options[name]), formMetaData, filledProps);
          } else if (_lodash["default"].isArray(metaData[pro])) {
            for (var i = 0; i < metaData[pro].length; i++) {
              var obj = metaData[pro][i];
              flag = backfill(obj, (0, _defineProperty2["default"])({}, name, options[name]), formMetaData, filledProps);

              if (flag) {
                break;
              }
            }
          } else if (metaData[pro] instanceof Promise) {
            metaData[pro].then(function (meteData) {
              backfill(meteData["default"], options, formMetaData, filledProps);
              return meteData;
            });
          }
        }
      }
    }
  }

  return flag;
} // 数据模式项设置不可用


function setItemDisabled(metaData) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var flag = false;

  for (var i = 0, len = ids.length; i < len; i++) {
    var name = ids[i];

    for (var pro in metaData) {
      if (Object.prototype.hasOwnProperty.call(metaData, pro)) {
        if (metaData.$id === name) {
          var $el = metaData.$el || {};
          $el.disabled = disabled;
          metaData.$el = $el;
          flag = true;
          break;
        } else if (_lodash["default"].isPlainObject(metaData[pro])) {
          setItemDisabled(metaData[pro], [name], disabled);
        } else if (_lodash["default"].isArray(metaData[pro])) {
          for (var _i = 0; _i < metaData[pro].length; _i++) {
            var obj = metaData[pro][_i];
            flag = setItemDisabled(obj, [name], disabled);

            if (flag) {
              break;
            }
          }
        }
      }
    }
  }

  return flag;
} // 根据componentName获取父组件


function getParent(componentName) {
  var parent = this.$parent || this.$root;
  var name = parent.$options.componentName;

  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent;

    if (parent) {
      name = parent.$options.componentName;
    }
  }

  return parent;
} // 根据componentName获取当前组件的子组件


function getChild(parent, componentName) {
  var child;

  for (var index = 0, length = parent.$children.length; index < length; index++) {
    var element = parent.$children[index]; // var name = element.$vnode.tag.indexOf(componentName);

    var name = element.$vnode.componentOptions.Ctor.extendOptions.componentName;

    if (element && name && name === componentName) {
      child = element;
      break;
    } else {
      child = getChild(element, componentName);

      if (child) {
        return child;
      }
    }
  }

  return child;
} // bcrypt加密


function bcryptEncryption(bcrypt, password) {
  // 生成salt的迭代次数
  var saltRounds = 10; // 随机生成salt

  var salt = bcrypt.genSaltSync(saltRounds); // 获取hash值

  password = bcrypt.hashSync(password, salt);
  return password;
} // 小数点后两位百分比


function percentage(num, total) {
  var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (num === 0 || total === 0) {
    return unit ? '0.0%' : 0;
  }

  return Math.round(num / total * 10000) / 100.0 + (unit ? '%' : 0);
}

function normalSize(size) {
  var isSpeed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!size) {
    return isSpeed ? '0.00bps' : '0.00B';
  }

  var num = 1024.0; // byte

  if (size < num) {
    return size.toFixed(2) + (isSpeed ? 'bps' : 'B');
  }

  if (size < Math.pow(num, 2)) {
    return (size / num).toFixed(2) + (isSpeed ? 'Kbps' : 'KB');
  } // kB


  if (size < Math.pow(num, 3)) {
    return (size / Math.pow(num, 2)).toFixed(2) + (isSpeed ? 'Mbps' : 'MB');
  } // MB


  if (size < Math.pow(num, 4)) {
    return (size / Math.pow(num, 3)).toFixed(2) + (isSpeed ? 'Gbps' : 'GB');
  } // GB


  return (size / Math.pow(num, 4)).toFixed(2) + (isSpeed ? 'Tbps' : 'TB'); // TB
}

function normalTimes(secondTime) {
  var second = parseInt(secondTime);
  var min = 0;
  var hour = 0;
  var day = 0;
  var month = 0;
  var year = 0;
  var str = '';

  if (second >= 60) {
    var seconds = second;
    second = seconds % 60;
    min = parseInt(seconds / 60);

    if (min >= 60) {
      var mins = min;
      min = mins % 60;
      hour = parseInt(mins / 60);

      if (hour >= 24) {
        var hours = hour;
        hour = hours % 24;
        day = parseInt(hours / 24);
      }

      if (day >= 30) {
        var days = day;
        day = days % 30;
        month = parseInt(days / 30);
      }

      if (month >= 12) {
        var months = month;
        month = months % 12;
        year = parseInt(months / 12);
      }
    }
  }

  if (year > 0) {
    str += year + '年';
  }

  if (month > 0) {
    str += month + '个月';
  }

  if (day > 0) {
    str += day + '天';
  }

  if (hour > 0) {
    str += hour + '小时';
  }

  if (min > 0) {
    str += min + '分';
  }

  if (second > 0) {
    str += second + '秒';
  }

  return str || 0 + '秒';
}

function getItemById(items, id) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '$id';
  var curItem;

  for (var index = 0; index < items.length; index++) {
    var item = items[index];

    if (item[key] === id) {
      curItem = item;
      break;
    } else if (!curItem && _lodash["default"].isArray(item.$items)) {
      curItem = getItemById(item.$items, id, key);
    }
  }

  return curItem;
}

function getValueByKey(object, key) {
  if (!key) {
    return;
  }

  var value;

  if (Array.isArray(object)) {
    object.forEach(function (item) {
      var temp = getValueByKey(item, key);

      if (temp) {
        value = temp;
      }
    });
  } else if ((0, _isObject["default"])(object)) {
    var temp = object[key];

    if (temp) {
      value = temp;
    } else {
      for (var objKey in object) {
        var objValue = object[objKey];

        if (!Array.isArray(objValue) && !(0, _isObject["default"])(objValue)) {
          continue;
        }

        temp = getValueByKey(objValue, key);

        if (temp) {
          value = temp;
        }
      }
    }
  }

  return value;
}
/**
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [stop]
 * @returns {Object} Returns `object`.
 */


function setByPropPath(object, path, value, customizer) {
  var stop = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (!(0, _isObject["default"])(object)) {
    return object;
  }

  path = (0, _castPath["default"])(path, object);
  var index = -1;
  var length = path.length;
  var lastIndex = length - 1;
  var nested = object;

  while (nested != null && ++index < length && !stop) {
    var key = (0, _toKey["default"])(path[index]);
    var newValue = value;

    if (index !== lastIndex) {
      var objValue; // 当包含 "=" 时，则开启查询模式

      if (key.indexOf('=') > -1) {
        (function () {
          var keys = key.split('=');
          objValue = _lodash["default"].find(nested, function (obj) {
            return obj[keys[0]] === keys[1];
          }) || nested[key];
        })();
      } else {
        objValue = nested[key];
      }

      if (objValue instanceof Promise) {
        stop = true;
        objValue.then(function (meteData) {
          setByPropPath(meteData["default"], path.slice(index, path.length), value, false);
          objValue = meteData["default"];
          return meteData;
        });
      } else {
        newValue = (0, _isObject["default"])(objValue) ? objValue : (0, _isIndex["default"])(path[index + 1]) ? [] : {};
      }
    }

    if (!stop) {
      // 查询到则跳过赋值，直接进入下一层
      if ((0, _isObject["default"])(objValue) && key.indexOf('=') > -1) {
        nested = objValue;
      } else {
        (0, _assignValue["default"])(nested, key, newValue);
        nested = nested[key];
      }
    }
  }

  return object;
}